module.exports = __webpack_public_path__ + "static/media/new-products-item-3.acec740c.png";